import React from 'react';
import './index.scss';
import AsyncSection from '../../../../../../../../../../Components/AsyncSection';
import { BANNER_HEIGHT, BANNER_TEXT, intervalSentence } from './constants';

// Heads the trend sections with what they are all reading: who was compared,
// who couldn't be, and the two conventions every section below applies. It
// states the scope once so each section can get on with its own subject.
//
// Wrapped in AsyncSection against the same call its interval range comes from,
// so it keeps step with the sections it introduces: the same GraphLoader stands
// in while they load — drawn at the band's own height, so the content lands
// where the loader was — and a response that is empty, failed or gated takes the
// banner with it rather than leaving a heading over nothing.
//
// Everything it states comes from the store (see index.js) — nothing here is a
// stand-in any more.
const ComparingBanner = ({
    api,
    comparedCount,
    notComparedCount,
    baselineLabel,
    intervalFrom,
    intervalTo,
}) => (
    <AsyncSection api={api} loaderHeight={BANNER_HEIGHT}>
        {/* Nobody compared means the sections below have nothing to show either,
            so the band goes with them rather than announcing a comparison of
            none — which is also what it shows for the moment before the
            participant lists have answered. */}
        {comparedCount > 0 && <div className='comparing-banner'>
            <span className='comparing-banner__eyebrow'>{BANNER_TEXT.eyebrow}</span>

            {/* Named by the pairing the results are built from, so the sentence
                says what the sections below actually measured against — "their
                previous 360" or "their very first 360". */}
            <p className='comparing-banner__headline'>
                <strong>{comparedCount} {BANNER_TEXT.comparedUnit}</strong> {BANNER_TEXT.comparedClause} {baselineLabel || BANNER_TEXT.comparedDefaultBaseline}

                {/* Everyone matched leaves nothing to set aside, so the second half
                    drops out rather than announcing a zero. */}
                {notComparedCount > 0 && (
                    <>
                        <span className='comparing-banner__separator'>·</span>
                        <strong>{notComparedCount} {BANNER_TEXT.notCompared}</strong>
                    </>
                )}
            </p>

            {/* The muted rule always holds; the intervals are only described when
                the response said what they were. Joined rather than rendered side by
                side so a missing range doesn't leave a space before the full stop. */}
            <p className='comparing-banner__note'>
                {[intervalSentence(intervalFrom, intervalTo), BANNER_TEXT.muted].filter(Boolean).join(' ')}
            </p>
        </div>}
    </AsyncSection>
);

export default ComparingBanner;
